/**
 * Generic Windows-style alphanumeric sort for object arrays.
 * @param {Object} a - First object to compare.
 * @param {Object} b - Second object to compare.
 * @param {string} key - Key in the object to use for sorting.
 * @returns {number}
 */
export const resourceSortWindowsFormat = (a, b, key) => {
  const regex = /(\d+|\D+)/g;
  const aParts = (a[key] || "").match(regex) || [];
  const bParts = (b[key] || "").match(regex) || [];
  const maxLen = Math.max(aParts.length, bParts.length);

  for (let i = 0; i < maxLen; i++) {
    const aPart = aParts[i] || "";
    const bPart = bParts[i] || "";

    if (/^\d+$/.test(aPart) && /^\d+$/.test(bPart)) {
      const aNum = Number(aPart);
      const bNum = Number(bPart);
      if (aNum !== bNum) return aNum - bNum;
      if (aPart.length !== bPart.length) return bPart.length - aPart.length;
    } else {
      const cmp = aPart.localeCompare(bPart, undefined, { sensitivity: "base" });
      if (cmp !== 0) return cmp;
    }
  }
  return 0;
};
